// Import polyfill from node_modules
// import 'core-js/modules/es6.set.js'
// import 'core-js/modules/es6.array.find-index.js'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger';
import Swiper, { Controller, Lazy, Parallax, EffectFade, Pagination } from 'swiper';
import Cotton from 'cottonjs'
import { useCircleBtn } from './components/btn'
import { useParallax, useImageParallax } from './modules/_utils'
import { throttle } from './modules/_fn';

gsap.registerPlugin(ScrollTrigger)

// section feature swipers
const useFeatureSwiper = () => {
	const featureSensor = $('#feature-sensor')
	const gel = $('.feature-photo_gel')

	if (!featureSensor.length || !gel.length) return;
	// feature-photo-swiper
	const featurePhotoSwiper = new Swiper('#feature-photo-swiper', {
		modules: [Controller, Lazy, Parallax, Pagination],
		speed: 500,
		spaceBetween: 28,
		parallax: true,
		pagination: {
			el: '.feature-progress'
		},
		lazy: {
			loadPrevNext: true,
			loadPrevNextAmount: 2
		},
		breakpoints: {
			1024: {
				spaceBetween: 0,
			}
		},
		on: {
			slideChangeTransitionStart() {
				gel.addClass('is-switching')
			},
			slideChangeTransitionEnd() {
				gel.removeClass('is-switching')
			}
		}
	})

	// feature-text-swiper
	const featureTextSwiper = new Swiper('#feature-text-swiper', {
		modules: [Controller, EffectFade],
		speed: 500,
		autoHeight: true,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		}
	})

	// Gsap
	const mm = gsap.matchMedia()
	mm
		// 電腦版
		.add('(min-width: 1024px)', () => {
			featurePhotoSwiper.$el.addClass('swiper-no-swiping')
			featurePhotoSwiper.controller.control = undefined
			featureTextSwiper.controller.control = undefined
			gsap.timeline({
				scrollTrigger: {
					trigger: featureSensor[0],
					start: 'top top',
					end: 'bottom bottom',
					scrub: true,
					// markers: true,
					onUpdate: e => {
						const { progress } = e
						const { activeIndex: photoActiveIndex } = featurePhotoSwiper
						const { activeIndex: textActiveIndex } = featureTextSwiper
						
						featurePhotoSwiper.setProgress(progress)

						if (photoActiveIndex === textActiveIndex) return;
						featureTextSwiper.slideTo(photoActiveIndex)
					}
				}
			})
		})
		// 手機版
		.add('(max-width: 1023px)', () => {
			featurePhotoSwiper.$el.removeClass('swiper-no-swiping')
			featurePhotoSwiper.controller.control = featureTextSwiper
			featureTextSwiper.controller.control = featurePhotoSwiper
		})
}

// section achieve counter
const useAchieveCounter = () => {
	const counters = $('[data-counter]')
	const baseTrans = 1.2
	counters.each((i, el) => {
		const counter = $(el)
		const num = counter.attr('data-counter')
		const numArray = num.split('')
		
		// 塞入 counter 結構
		let letters = ''
		numArray.forEach(() => {
			const randomTrans = (Math.random() / 2 + baseTrans).toFixed(2)
			letters += `
			<span class="letter-wrap" style="display: block; overflow: hidden; text-align: left;">
				<span class="letter font-serif" style="display: inline-block; line-height: 1.2; letter-spacing: 0em; font-size: var(--counter-size, 78px); transform: translate(0, 0); transition-duration: ${randomTrans}s; transition-timing-function: cubic-bezier(0.1, 0.66, 0.22, 1); pointer-events: none;" aria-hidden="true">
					<span>0</span><br /><span>1</span><br /><span>2</span><br /><span>3</span><br /><span>4</span><br /><span>5</span><br /><span>6</span><br /><span>7</span><br /><span>8</span><br /><span>9</span><br /><span>0</span><br /><span>1</span><br /><span>2</span><br /><span>3</span><br /><span>4</span><br /><span>5</span><br /><span>6</span><br /><span>7</span><br /><span>8</span><br /><span>9</span>
				</span>
			</span>
			`
		})
		const counterWrap = $(`
			<div aria-hidden="true">
				<span class="show-for-sr">${num}</span>
				<div style="display: flex;">
					${letters}
				</div>
			</div>
		`)

		counter.find('.item-counter_num').append(counterWrap)

		// 設定高度
		const letterWrap = counterWrap.find('.letter-wrap')
		const height = letterWrap.innerHeight() / 20
		letterWrap.innerHeight(height)

		// Gsap
		gsap.timeline({
			scrollTrigger: {
				trigger: counterWrap[0],
				start: 'top 75%',
				// markers: true,
				onEnter: () => {
					const lettersEle = counterWrap.find('.letter')
					numArray.forEach((num, i) => {
						const targetNum = Number(num)
						const targetSpan = lettersEle.find('span')[targetNum]
						const { width, height } = targetSpan.getBoundingClientRect()
						lettersEle[i].style.transform = `translate(0, ${-50 - 5 * targetNum}%)`
						letterWrap
							.innerWidth(width)
							.innerHeight(height)
						counter.addClass('is-show')
					})
				}
			}
		})
	})
}

// section case swiper
const useCaseSwiper = () => {
	let caseSwiper
	const useCaseSwiper = () => {
		return new Swiper('#case-swiper', {
			speed: 500,
			slidesPerView: 1.5,
			spaceBetween: 20,
			breakpoints: {
				1024: {
					slidesPerView: 2
				},
				1280: {
					slidesPerView: 2.5
				},
				1441: {
					slidesPerView: 3
				}
			}
		})
	}

	const mm = gsap.matchMedia()
	mm
		// 手機版 swiper destroy
		.add('(max-width: 767px)', () => {
			if (caseSwiper) {
				caseSwiper.destroy(true, true)
			}
		})
		// 電腦版 swiper init
		.add('(min-width: 768px)', () => {
			if (!caseSwiper || caseSwiper.destroyed) {
				caseSwiper = useCaseSwiper()
			}
		})
}

// section case cursor
const useCaseCursor = () => {
	const scene = document.querySelector('#case-swiper')
	if (!scene) return;

	new Cotton('#case-cursor', {
		scene
	})
}

// section product scroll animation
const useProductAnimation = () => {
	const product = $('#product')
	if (!product.length) return;

	const bgDot = product.find('.product-bg_dot')

	// 設定 dot 寬高
	const setDotSize = () => {
		const secWidth = product.outerWidth()
		const secHeight = product.outerHeight()
		const dotSize = Math.max(secWidth, secHeight) * 2.2
		bgDot.css({ width: `${dotSize}px`, height: `${dotSize}px` })
	}

	setDotSize()
	$(window).on('resize', throttle(setDotSize, 50, 100))
	
	// GSAP
	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: bgDot[0],
			start: 'top 75%',
			end: '+=30%',
			scrub: true,
			once: true,
			// markers: true,
			onUpdate: e => {
				const { progress, start, end } = e
				const top = progress * (end - start)
				bgDot.css({ top })
			}
		}
	})

	tl
		.fromTo(bgDot[0], { scale: 0 }, { scale: 0.3 })
		.call(() => {
			setTimeout(() => {
				product.addClass('is-animate')
			}, 200)
		})
}


$(() => {
	// pages function
	useFeatureSwiper()
	useAchieveCounter()
	useCaseSwiper()
	useCaseCursor()
	useProductAnimation()

	// components function
	useCircleBtn()
	useParallax()
	useImageParallax()
})
